export default {
  confirm_password: { id: 'confirm_password' },
  new_password: { id: 'new_password' },
  submit: { id: 'submit' },
}
